export const Logo = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <path d="M14 54V30a18 18 0 0 1 36 0v24" fill="none" stroke="#C5A059" strokeWidth="2" />
    <path d="M32 17l2.6 9.4L44 29l-9.4 2.6L32 41l-2.6-9.4L20 29l9.4-2.6z" fill="#E5C158" />
    <path d="M10 54h44" stroke="#C5A059" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export const Wordmark = () => (
  <span className="flex items-center gap-3">
    <Logo />
    <span className="leading-none text-left whitespace-nowrap">
      <span className="block font-display text-[1.2rem] sm:text-[1.35rem] tracking-tight text-[#F9F9F9]">Turismo da Capital</span>
      <span className="block text-[10px] uppercase tracking-[0.35em] text-[#C5A059] mt-1">Lisboa · Portugal</span>
    </span>
  </span>
);
